import React from 'react';

export const BadgeCell = ({ item }: { item: OperatorFlowJob }) => {
  const badges = [];
  if (item.rolledBackOperatorFlowJobId) {
    badges.push({ text: 'Redeploy' });
  }
  return (
    <div>
      {badges.map((badge) => (
        <span className="badge" key={badge.text}>
          {badge.text}
        </span>
      ))}
    </div>
  );
};
